import React from 'react'
import { LoginForm } from '../components/LoginForm'


export function Login() {
    return (
        <div>
            <LoginForm />
        </div>
    )
}

